import {
  PA_FETCH_ALL_TRAINERS,
  PA_FETCH_ALL_TRAINERS_FAILURE,
  PA_FETCH_ALL_TRAINERS_SUCCESS,

  PA_NEXT_FORM_STEP,
  PA_PREVIOUS_FORM_STEP,
  PA_RESET_FORM_STEP,

  PHYSICALLY_APPROVE_TRAINER,
  PHYSICALLY_APPROVE_TRAINER_SUCCESS,
  PHYSICALLY_APPROVE_TRAINER_FAILURE,
  PHYSICALLY_APPROVE_TRAINER_RESET,

  UPDATE_CURRENT_TRAINING_CENTER_ID,
  RESET_CURRENT_TRAINING_CENTER_ID,

  PA_FETCH_TRAINER_BY_ID,
  PA_FETCH_TRAINER_BY_ID_SUCCESS,
  PA_FETCH_TRAINER_BY_ID_FAILURE,
  PA_RESET_TRAINER_BY_ID,

  EXPORT_PHYSICALLY_APPROVED_TRAINERS,
  EXPORT_PHYSICALLY_APPROVED_TRAINERS_SUCCESS,
  EXPORT_PHYSICALLY_APPROVED_TRAINERS_FAILURE,
  EXPORT_PHYSICALLY_APPROVED_TRAINERS_RESET
} from "../ActionTypes";

const INIT_STATE = {
  paAllTrainersList: [],
  paAllTrainersMeta: {},
  fetchingTrainers: false,
  trainersFetchedSuccessfully: false,

  paCurrentFormStep: 0,
  currentTrainingCenterId: "",

  physicallyApprovingTrainer: false,
  physicalApprovalSuccess: false,

  singleTrainerDetails: {},
  fetchingSingleTrainer: false,
  singleTrainerFetchedSuccessfully: false,

  approvalResults: {},

  exportingPaTrainers: false,
  exportPaTrainersSuccess: false,
}

function reducers(state = INIT_STATE, action) {
  switch (action.type) {
    case PA_FETCH_ALL_TRAINERS: return {
      ...state,
      fetchingTrainers: true,
    }

    case PA_FETCH_ALL_TRAINERS_SUCCESS: {
      return {
        ...state,
        fetchingTrainers: false,
        trainersFetchedSuccessfully: true,
        paAllTrainersList: action.payload.data,
        paAllTrainersMeta: action.payload.meta,
      }
    }

    case PA_FETCH_ALL_TRAINERS_FAILURE: return {
      ...state,
      fetchingTrainers: false,
      trainersFetchedSuccessfully: false,
    }

    case PA_NEXT_FORM_STEP: {
      return {
        ...state,
        paCurrentFormStep: state.paCurrentFormStep + 1,
        approvalResults: {
          ...state.approvalResults,
          ...action?.payload,
        }
      }
    }

    case PA_PREVIOUS_FORM_STEP: return {
      ...state,
      paCurrentFormStep: state.paCurrentFormStep - 1,
      approvalResults: {
        ...state.approvalResults,
        ...action.payload,
      }
    }

    case PA_RESET_FORM_STEP: return {
      ...state,
      paCurrentFormStep: action.payload ?? 0,
    }

    case PHYSICALLY_APPROVE_TRAINER: return {
      ...state,
      physicallyApprovingTrainer: true,
    }

    case PHYSICALLY_APPROVE_TRAINER_SUCCESS: return {
      ...state,
      physicallyApprovingTrainer: false,
      physicalApprovalSuccess: true
    }

    case PHYSICALLY_APPROVE_TRAINER_FAILURE: return {
      ...state,
      physicallyApprovingTrainer: false,
      physicalApprovalSuccess: false,
    }

    case PHYSICALLY_APPROVE_TRAINER_RESET: return {
      ...state,
      physicallyApprovingTrainer: false,
      physicalApprovalSuccess: false,
    }

    case UPDATE_CURRENT_TRAINING_CENTER_ID: {
      return {
        ...state,
        currentTrainingCenterId: action.id,
        paCurrentFormStep: 0,
        approvalResults: {
          ...state.approvalResults,
          skillCenterId: action.id,
        }
      }
    }

    case RESET_CURRENT_TRAINING_CENTER_ID: return {
      ...state,
      currentTrainingCenterId: "",
      paCurrentFormStep: 0,
    }

    case PA_FETCH_TRAINER_BY_ID: return {
      ...state,
      fetchingSingleTrainer: true,
    }

    case PA_FETCH_TRAINER_BY_ID_SUCCESS: {
      return {
        ...state,
        fetchingSingleTrainer: false,
        singleTrainerFetchedSuccessfully: true,
        singleTrainerDetails: action.payload,
      }
    }

    case PA_FETCH_TRAINER_BY_ID_FAILURE: return {
      ...state,
      fetchingSingleTrainer: false,
      singleTrainerFetchedSuccessfully: false,
    }

    case PA_RESET_TRAINER_BY_ID: return {
      ...state,
      singleTrainerDetails: {},
    }

    case EXPORT_PHYSICALLY_APPROVED_TRAINERS: return {
      ...state,
      exportingPaTrainers: true,
    }

    case EXPORT_PHYSICALLY_APPROVED_TRAINERS_SUCCESS: return {
      ...state,
      exportingPaTrainers: false,
      exportPaTrainersSuccess: true
    }

    case EXPORT_PHYSICALLY_APPROVED_TRAINERS_FAILURE: return {
      ...state,
      exportingPaTrainers: false,
      exportPaTrainersSuccess: false
    }

    case EXPORT_PHYSICALLY_APPROVED_TRAINERS_RESET: return {
      ...state,
      exportingPaTrainers: false,
      exportPaTrainersSuccess: false,
    }

    default: return state;
  }
}

export default reducers;